<template>
  <div>
    <b-container class="services">
      <b-row style="padding: 60px 0">
        <b-col sm="4" v-for="news in data" :key="news.added">
          <div class="post-module">
            <div class="thumbnail">
              <!-- <div class="date">
                Posted
                {{ parseInt(news.added) | moment("from", "now") }}
              </div> -->
              <img :src="news.imageURL" alt="" />
            </div>
            <div class="post-content">
              <div class="category">{{ news.category }}</div>
              <h1 class="title">
                <router-link :to="`news-detail/` + news.slug">
                  {{ news.title }}
                </router-link>
              </h1>
              <p
                class="description"
                v-html="news.description.substring(0, 200)"
              ></p>
              <div class="post-meta">
                <span class="comments">
                  By:
                  {{ news.addedBy }}
                </span>
                <span class="timestamp" style="margin-left: 15px">
                  <b-icon icon="clock"></b-icon>
                  {{
                    parseInt(news.added)
                      | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                  }}
                </span>
              </div>
            </div>
          </div>
        </b-col>
        <b-col sm="4">
          <!--<div class="card card-2">
            <iframe
              width="400"
              height="500"
              src="https://www.youtube.com/embed/cAQAhIne8Ho"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>-->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      buttonName: "Know More",
      data: []
    };
  },
  firestore: {
    data: db.collection("news").orderBy("added")
  }
};
</script>

<style lang="scss" scoped>
a,
a:hover {
  color: #333 !important;
  text-decoration: none;
  border: 0;
  outline: none;
}
.post-module {
  position: relative;
  z-index: 1;
  display: block;
  background: #ffffff;
  min-width: 270px;
  height: 500px;
  -webkit-box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);
  // -webkit-box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  // -moz-box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s linear 0s;
  -moz-transition: all 0.3s linear 0s;
  -ms-transition: all 0.3s linear 0s;
  -o-transition: all 0.3s linear 0s;
  transition: all 0.3s linear 0s;
}
// .post-module:hover,
// .hover {
//   -webkit-box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.3);
//   -moz-box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.3);
//   box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.3);
// }
.post-module:hover .thumbnail img,
.hover .thumbnail img {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 0.6;
}
.post-module .thumbnail {
  background: #000000;
  height: 400px;
  overflow: hidden;
}
.post-module .thumbnail .date {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.1);
  width: auto;
  height: 35px;
  padding: 5px 10px;
  color: #af0000;
  font-weight: 400;
  text-align: center;
  -webkti-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.post-module .thumbnail .date .day {
  font-size: 15px;
}
.post-module .thumbnail .date .month {
  font-size: 9px;
  text-transform: uppercase;
}
.post-module .thumbnail img {
  display: block;
  width: 100%;
  -webkit-transition: all 0.3s linear 0s;
  -moz-transition: all 0.3s linear 0s;
  -ms-transition: all 0.3s linear 0s;
  -o-transition: all 0.3s linear 0s;
  transition: all 0.3s linear 0s;
}
.post-module .post-content {
  position: absolute;
  bottom: 0;
  background: #ffffff;
  width: 100%;
  padding: 30px;
  -webkti-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
  -moz-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
  -ms-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
  -o-transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
  transition: all 0.3s cubic-bezier(0.37, 0.75, 0.61, 1.05) 0s;
}
.post-module .post-content .category {
  position: absolute;
  top: -34px;
  left: 0;
  background: #af0000;
  padding: 10px 15px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}
.post-module .post-content .title {
  margin: 0;
  padding: 0 0 10px;
  color: #333333;
  font-size: 26px;
  font-weight: 700;
}
.post-module .post-content .sub_title {
  margin: 0;
  padding: 0 0 20px;
  color: #af0000;
  font-size: 20px;
  font-weight: 400;
}
.post-module .post-content .description {
  // display: none;
  color: #666666;
  font-size: 14px;
  line-height: 1.8em;
  height: auto !important;
}
.post-module .post-content .post-meta {
  margin: 30px 0 0;
  color: #999999;
}
.post-module .post-content .post-meta .timestamp {
  margin: 0 16px 0 0;
}
.post-module .post-content .post-meta a {
  color: #999999;
  text-decoration: none;
}
.hover .post-content .description {
  display: block !important;
  height: auto !important;
  opacity: 1 !important;
}

.container .column .demo-title {
  margin: 0 0 15px;
  color: #666666;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}
.container .info {
  width: 300px;
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.container .info span {
  color: #666666;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #af0000;
}
</style>
